// extracted by mini-css-extract-plugin
export default {"block":"NotFound_block__vH9x7","title":"NotFound_title__D8KzW","title__text":"NotFound_title__text__vGMIb","description":"NotFound_description__lEY4Z","btn":"NotFound_btn__i6AKB"};